import { Check, CaretDown } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { CONTENT_TYPE_CATEGORIES, MULTI_SECTION_TYPES } from "@/lib/generateConstants";

export function ContentTypeCombobox({ contentType, onSelect, isMultiSection, open, onOpenChange }) {
  return (
    <div>
      <label className="block font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[var(--text-muted)] mb-2">
        Content Type <span className="text-[#FF4400]">*</span>
      </label>
      <Popover open={open} onOpenChange={onOpenChange}>
        <PopoverTrigger asChild>
          <button
            type="button"
            role="combobox"
            aria-expanded={open}
            className="flex w-full items-center justify-between rounded-md border bg-[var(--bg-card)] border-[var(--border-strong)] text-[var(--text-primary)] px-3 h-11 text-sm focus:ring-1 focus:ring-[#FF4400] focus:outline-none hover:border-[var(--text-muted)] transition-colors"
            data-testid="select-content-type"
          >
            <span className={contentType ? "text-[var(--text-primary)]" : "text-[var(--text-muted)]"}>
              {contentType ? (MULTI_SECTION_TYPES.includes(contentType) ? `${contentType} ✦` : contentType) : "Search or select type..."}
            </span>
            <CaretDown size={14} className="text-[var(--text-muted)] shrink-0 ml-2" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0 bg-[var(--bg-raised)] border-[var(--border-strong)]" align="start">
          <Command className="bg-transparent">
            <CommandInput placeholder="Search content types..." className="text-[var(--text-primary)] placeholder:text-[var(--text-muted)]" />
            <CommandList className="max-h-[280px]">
              <CommandEmpty className="text-[var(--text-muted)] text-sm">No content type found.</CommandEmpty>
              {CONTENT_TYPE_CATEGORIES.map((cat) => (
                <CommandGroup key={cat.label} heading={cat.label} className="[&_[cmdk-group-heading]]:text-[var(--text-muted)] [&_[cmdk-group-heading]]:text-[10px] [&_[cmdk-group-heading]]:uppercase [&_[cmdk-group-heading]]:tracking-wider [&_[cmdk-group-heading]]:font-semibold">
                  {cat.items.map((item) => (
                    <CommandItem
                      key={item}
                      value={item}
                      onSelect={() => { onSelect(item); onOpenChange(false); }}
                      className="text-[var(--text-secondary)] cursor-pointer data-[selected=true]:bg-[var(--accent-subtle)] data-[selected=true]:text-[#FF4400]"
                    >
                      <span className="flex-1">{item}</span>
                      {MULTI_SECTION_TYPES.includes(item) && <span className="text-[10px] text-[var(--text-muted)] ml-1">✦ multi</span>}
                      {contentType === item && <Check size={14} className="text-[#FF4400] shrink-0" />}
                    </CommandItem>
                  ))}
                </CommandGroup>
              ))}
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
      {isMultiSection && (
        <p className="text-xs text-[var(--success)] mt-1 font-['JetBrains_Mono']" data-testid="multi-section-hint">
          ✦ MULTI-SECTION MODE — will generate each section separately
        </p>
      )}
    </div>
  );
}
